<template>
  <div
    :ref="'refWeekPersonal'"
    class="week-personal"
    :class="{
      bottomBar:
        isMyPersonal &&
        (showDeadlineMissedBottomBar ||
          anyEntryChanged ||
          (repeatScheduleShow && isThereAnythingToCopyFromLastFewWeeks && !(fetchingEntries && !selectWeekShow) && !submittingEntries)),
    }"
  >
    <div :ref="'weekWrapper'" class="week-wrapper">
      <transition name="fadeEqual">
        <div v-if="isMyPersonal" class="dashed-cal-border">
          <transition name="fade">
            <div
              v-if="showClickAndDragPlaceholder && !fetchingEntries"
              v-show="$refs['refCalWithTime'].getBoundingClientRect().height >= 380"
              class="click-schedule-image"
            >
              <img :src="require('@/assets/_desktop/_calendars/click-placeholder.svg')" />
              {{ isFarInFuture ? $t('scheduleYourTimeOff') : $t('scheduleYourWork') }}
            </div>
          </transition>
        </div>
      </transition>
      <transition name="fadeEqual">
        <div v-if="isMyPersonal && showDeadlineMissedBottomBar && !anyEntryChanged" class="dashed-cal-border warning-border" />
      </transition>
      <div
        class="time-timezone"
        :style="{
          'min-width': windowWidth >= 768 ? '150px' : '75px',
          width: windowWidth >= 768 ? '150px' : '75px',
        }"
        @click="openChangeTimezonePopup()"
      >
        <div v-if="windowWidth >= 768">
          {{ timezoneCity }}
        </div>
        <img v-else :src="require('@/assets/_desktop/_calendars/timezone-switch.svg')" />
      </div>
      <div :ref="'refCalWithTime'" class="calendar-with-time" @scroll="handleScroll">
        <div
          :ref="'timeColRef'"
          class="time-column"
          :style="{
            height: hour_height * 24 + 45 + 3 + 'px',
            'min-width': windowWidth >= 768 ? '150px' : '75px',
            width: windowWidth >= 768 ? '150px' : '75px',
          }"
        >
          <div
            v-for="i in 25"
            :key="i"
            class="time-text"
            :style="{
              top: (i - 1) * hour_height + 43 + 'px',
            }"
          >
            {{ formatHours(i - 1) }}
          </div>
          <div
            v-if="lineVisible"
            class="now-time"
            :style="{
              top: nowTimeTop + 'px',
              left: windowWidth >= 768 ? '14px' : '0px',
            }"
          >
            {{ nowTime }}
          </div>
          <div
            class="dashed-line"
            :style="{
              top: topLineOffset + 'px',
              width: '99%',
            }"
          />
        </div>
        <div
          v-if="entries"
          id="calendarGrid"
          :key="'calendarKey'"
          :ref="'calendarGrid'"
          class="calendar-grid"
          :style="{
            width: `calc(100% - ${windowWidth >= 768 ? 150 : 75}px)`,
            left: `${windowWidth >= 768 ? 150 : 75}px`,
          }"
        >
          <div v-if="lineVisible">
            <div
              :ref="'calendarLine'"
              class="straight-line"
              :style="{
                top: topLineOffset + 'px',
                width: straightLineWidth + 'px',
                left: leftStraightLineOffset + 'px',
              }"
            />
            <div
              :ref="'calendarLine'"
              class="dashed-line"
              :style="{
                top: topLineOffset + 'px',
                width: dashedLineWidth + 'px',
              }"
            />
          </div>
          <div
            v-for="d in amountOfDays"
            :key="'dayHeader' + d"
            :style="{
              flex: 1,
            }"
          >
            <div class="dayColumn">
              <div
                class="column-date"
                :class="{
                  today: currentTime.isBefore(moment(startDate).add(d, 'days')) && currentTime.isSameOrAfter(moment(startDate).add(d - 1, 'days')),
                  weekendDay:
                    moment(startDate)
                      .tz(userTimezone)
                      .add(d - 1, 'days')
                      .day() === 0 ||
                    moment(startDate)
                      .tz(userTimezone)
                      .add(d - 1, 'days')
                      .day() === 6,
                }"
              >
                <span class="week-day">
                  {{ $t('weekDaysShort')[(moment(startDate).tz(userTimezone).day() + d + 6) % 7].toUpperCase() }}
                </span>
                <span class="day-date">
                  {{
                    moment(startDate)
                      .tz(userTimezone)
                      .add(d - 1, 'days')
                      .date()
                  }}
                </span>
              </div>
            </div>
            <div :ref="'entryColumnRef'">
              <schedule-entry-column
                :id="'dayColumn' + (d - 1)"
                :ref="'refColumn'"
                :hour-height="hour_height"
                :is-my-personal="isMyPersonal"
                :submitting-entries="submittingEntries"
                :fetching-entries="fetchingEntries"
                :user-timezone="userTimezone"
                :entries="entries"
                :teams-dict="teamsDict"
                :dictionary="dictionary"
                :start-of-day="moment(startDate).add(d - 1, 'days')"
                :end-of-day="moment(startDate).add(d, 'days')"
                :start-of-week="startDate"
                :end-of-week="endDate"
                :current-time="currentTime"
                :day="d - 1"
                @entryBarUpdate="entryBarUpdate"
                @columnClicked="columnClicked"
                @activatedBar="activatedBar"
                @closePopup="closePopup"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :ref="'dragTimeWrapper'" class="drag-time-wrapper" :style="styleForDragTime(activeBar)">
      <div :ref="'drag-time'" class="drag-time">
        {{ dragTimeFromValue() }}
        <span v-if="isDragTimeTo()">&nbsp;- </span>
      </div>
      <div v-if="isDragTimeTo()" :ref="'drag-time'" class="drag-time">
        {{ dragTimeToValue() }}
      </div>
      <div v-if="shouldShowBlueTimezone()" class="drag-timezone">
        <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
          <g fill="#FFF" fill-rule="nonzero">
            <path
              d="M7 0a7 7 0 016.952 7.826 4.496 4.496 0 00-.698-.893l-.001-.106a6.245 6.245 0 00-.26-1.626h-2.628c.019.147.035.296.05.446a4.524 4.524 0 00-.749.01 11.777 11.777 0 00-.054-.457l-5.224.001A13.36 13.36 0 004.268 7c0 .628.043 1.233.12 1.803h1.44c-.072.24-.126.49-.158.745H4.514c.434 2.145 1.386 3.64 2.417 3.705a4.5 4.5 0 00.894.698A7 7 0 117 0zM3.753 9.548H1.286a6.272 6.272 0 003.877 3.433c-.646-.794-1.14-2.001-1.41-3.433zM3.635 5.2H1.007A6.255 6.255 0 00.745 7c0 .626.092 1.232.264 1.802h2.627A14.262 14.262 0 013.523 7c0-.621.039-1.224.112-1.799zm1.528-4.183l-.14.046a6.273 6.273 0 00-3.74 3.392h2.47c.269-1.434.764-2.642 1.41-3.438zM7 .745c-1.058 0-2.044 1.516-2.487 3.711h4.973l-.03-.148C9.016 2.274 8.107.858 7.119.75l-.12-.006zm1.837.274l.06.077c.618.795 1.09 1.972 1.35 3.36h2.47a6.272 6.272 0 00-3.88-3.437z"
            />
            <path
              d="M10.106 6.38a3.725 3.725 0 110 7.451 3.725 3.725 0 010-7.45zm1.816 1.91a.373.373 0 00-.527 0L9.84 9.843a.377.377 0 00-.104.203l-.005.06v2.446l.005.06a.373.373 0 00.74-.06v-2.293l1.444-1.442.044-.051a.373.373 0 00-.043-.475z"
            />
          </g>
        </svg>
        <span class="drag-timezone-name">
          {{
            activeEntry
              ? $store.state.timezonesGlobal.find((x) => x.value === (activeEntry.timezone ? activeEntry.timezone : activeEntry.location.timezone)).name
              : ''
          }}
        </span>
      </div>
    </div>
    <transition name="fade">
      <div
        v-if="
          isMyPersonal &&
          (showDeadlineMissedBottomBar ||
            anyEntryChanged ||
            (repeatScheduleShow && isThereAnythingToCopyFromLastFewWeeks && !(fetchingEntries && !selectWeekShow) && !submittingEntries))
        "
        class="repeat-schedule-bar"
        :class="{ 'warning-bar': showDeadlineMissedBottomBar && !anyEntryChanged }"
      >
        <div v-if="showDeadlineMissedBottomBar && !anyEntryChanged" class="r-s-start">
          <div class="r-s-text">
            {{ $t('redBottomBarText') }}
          </div>
          <div class="r-s-buttons">
            <button class="clavo-button clavo-button-danger-secondary" :style="{ margin: '0 10px' }" @click="showDeadlineMissedBottomBar = false">
              {{ $t('confirm') }}
            </button>
            <button class="clavo-button clavo-button-danger-primary" @click="showDeadlineMissedBottomBar = false">
              {{ $t('change') }}
            </button>
          </div>
        </div>
        <div v-else-if="!anyEntryChanged && !selectWeekShow" class="r-s-start">
          <div class="r-s-text">
            {{ $t('repeatYourScheduleFromAPreviousWeek') }}
          </div>
          <button class="clavo-button secondary align-right" @click="selectWeekClicked">
            {{ $t('repeatSchedule') }}
          </button>
        </div>
        <div v-else class="r-s-selected" :class="{ centered: anyEntryChanged }">
          <div v-if="!anyEntryChanged" class="r-s-left-section">
            <a class="arrow prev" @click.prevent="changeWeek(-1)">
              <img :src="require('@/assets/_desktop/_calendars/cal-arrow-white.svg')" />
            </a>
            <a class="arrow next" :class="{ disabled: weekIndex === -1 }" @click.prevent="changeWeek(1)">
              <img :style="{ opacity: weekIndex === -1 ? 0.5 : '' }" :src="require('@/assets/_desktop/_calendars/cal-arrow-white.svg')" />
            </a>
            <div class="r-s-s-text">
              {{ weekIndex === -1 ? $t('lastWeekSchedule') : $t('scheduleFromX', { x: selectDisplayedDate }) }}
            </div>
          </div>
          <div v-else class="r-s-s-text">
            {{ $t('saveYourSchedule') }}
          </div>
          <div class="r-s-buttons">
            <button class="clavo-button secondary" :style="{ margin: '0 10px' }" @click="submit">
              {{ $t('save') }}
            </button>
            <button class="clavo-button primary" @click="cancelClicked">
              {{ $t('cancel') }}
            </button>
          </div>
        </div>
      </div>
    </transition>
    <div class="schedulePopup">
      <!--  -->
      <transition name="epopup">
        <schedule-entry-popup
          v-if="schedulePopup.active && !submittingEntries"
          :key="entryKey + 'popup'"
          :ref="'entryPopup'"
          :entry="schedulePopup.entry"
          :entries="entries"
          :teams="teams"
          :filtered-teams="filteredTeams"
          :user-timezone="userTimezone"
          :locations-props="schedulePopup.locations"
          :is-my-personal="isMyPersonal"
          :submitting-entries="submittingEntries"
          :fetching-entries="fetchingEntries"
          :is-far-in-future="isFarInFuture"
          :style="
            windowWidth >= 768
              ? {
                  top: schedulePopup.positionY + 'px',
                  left: schedulePopup.positionX + 'px',
                }
              : {
                  left: '0px',
                  right: '0px',
                  bottom: '0px',
                }
          "
          class="schedulePopup"
          @holiday-changed="holidayChanged"
          @save-entry-params="() => {}"
          @close="closePopup"
          @entryChanged="entryChanged"
          @createEntryCopy="createEntryCopy"
          @deleteEntry="deleteEntry"
          @popupMounted="popupMounted"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import Parse from 'parse'
import User from '@/components/User'
import ParseFunctions from '@/components/ParseFunctions'
import ScheduleEntryColumn from '@/components/Personal/ScheduleEntryColumn'
import Constants from '@/components/Constants'
import ScheduleEntryPopup from '@/components/Personal/ScheduleEntryPopup'
import Color from '@/components/Color'
import moment from 'moment-timezone'
import Entry from '../../../clavo-shared/classes/Entry'
import { checkIfTargetFromClass, clearTextSelection, getAncestorOfClass } from '@/components/utils'
import { getLocationsCached } from '@/components/cache'
import { maxPossibleEntryFromStartPoint, collides, getBestFittingPlaceEntry } from '../../../clavo-shared/functions/collisions'
import { setBarTitle, setBarColor } from '@/components/Personal/ScheduleEntryColumn'
import EventBus from '@/EventBus'
import { calculateStoredEntriesKey } from '../../../clavo-shared/functions/entriesFetchTools'
import {
  getNextWeekStartDate,
  getNextWeekStartFromDate,
  getThisWeekStart,
  getWeekStartFromDate,
  isUSAMonthDayOrder,
} from '../../../clavo-shared/functions/time'

export default {
  components: {
    ScheduleEntryColumn,
    ScheduleEntryPopup,
  },

  mixins: [User, ParseFunctions, Constants, Color],

  props: {
    userTimezone: String,
    amountOfDays: {
      default: 7,
      type: Number,
    },
    isMyPersonal: {
      default: false,
      type: Boolean,
    },
    submittingEntries: {
      default: false,
      type: Boolean,
    },
    anyEntryChanged: {
      default: false,
      type: Boolean,
    },
  },

  data() {
    return {
      view_date: null,
      /** @type {[Entry]}
       * Local array of sorted entries. Unsubmitted changes affect that object */
      entries: undefined,
      /** @type {Date}
       * The first minute of the first displayed day */
      startDate: undefined,
      /** @type {Date}
       * The last minute of the last displayed day
       * (it's also the first minute of the first not displayed day - e.g 25-02-2020T00:00:00) */
      endDate: undefined,
      schedulePopup: {
        entryKey: 0,
        active: false,
        positionY: 0,
        positionX: 0,
        index: -1,
        day: 0,
        entry: null,
        location: null,
        time: {},
      },
      entryKey: 0,
      summaryKey: 0,
      /** @type {number}
       * Total amount of scheduled work time in current week (between startDate and endDate) */
      workScheduled: {
        total: 0,
      },
      holidayScheduled: 0,
      teams: [],
      filteredTeams: [], // teams with at least one location

      teamsDict: new Map(),
      dictionary: [],
      showHolidayDaysLeftPopup: false,

      //TODO hardcoded
      hour_height: undefined,
      hour_span: 3,
      hour_width: 50,
      xPosition_in_day: 22,
      name_width: 200,
      cell_padding: 8,
      activeBar: undefined,
      lastUpdatedEntry: undefined,
      activeEntry: undefined,
      popupCloseMode: undefined,
      currentTime: new moment(),
      calendarTopOffset: -10000,
      topLineOffset: -10000,
      leftStraightLineOffset: -10000,
      straightLineWidth: 0,
      leftDashedLineOffset: 0,
      dashedLineWidth: 0,
      refreshIntervalId: undefined,
      lineVisible: true,
      editMode: undefined,
      dayColumnOffsetTop: 0,
      userStartWeek: 'Sunday',
      firstBarOfDraggedEntryLeftOffset: 0,
      firstBarOfDraggedEntryColumnIndex: 0,
      weekIndex: 0,
      selectWeekShow: false,
      repeatScheduleShow: false,
      isThereAnythingToCopyFromLastFewWeeks: true,
      showClickAndDragPlaceholder: false,
      fetchingEntries: false,
      scrollStartTime: 6,
      isBarActivated: false,
      lastClickEvent: {},
      windowWidth: 0,
      bottomBar: false,
      timezoneCity: '',
      recreateBarsOnResizeTimeoutId: undefined,
      recreateBarsOnResizeTimeoutInterval: 250,
      nowTime: '',
      showDeadlineMissedBottomBar: false,
      overdueStatus: { userTeamWeekStatus: 'ok' },
    }
  },

  computed: {
    columns() {
      return this.$refs['refColumn']
    },
    startOfToday() {
      return this.currentTime.clone().tz(this.userTimezone).startOf('day')
    },
    selectDisplayedDate() {
      let dateMoment = moment(this.startDate).add(this.weekIndex, 'weeks')
      let currentYear = moment().format('YYYY')

      let start = getWeekStartFromDate(dateMoment, this.userStartWeek, this.userTimezone)

      let end = moment(start).tz(this.userTimezone).add(6, 'days')

      if (start.isSame(end, 'month')) {
        if (isUSAMonthDayOrder(this.$i18n.locale)) {
          return (
            start.formatLocalized('MMM D') + ' - ' + (currentYear === dateMoment.format('YYYY') ? end.formatLocalized('D') : end.formatLocalized('D, YYYY'))
          )
        } else {
          return (
            start.formatLocalized('D') + ' - ' + (currentYear === dateMoment.format('YYYY') ? end.formatLocalized('D MMM') : end.formatLocalized('D MMM, YYYY'))
          )
        }
      } else {
        if (start.format('YYYY') !== currentYear && end.format('YYYY') !== currentYear)
          return start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D, YYYY')
        else if (start.format('YYYY') !== end.format('YYYY')) return start.formatLocalized('MMM D, YYYY') + ' - ' + end.formatLocalized('MMM D, YYYY')
        else return start.formatLocalized('MMM D') + ' - ' + end.formatLocalized('MMM D')
      }
    },
    isFarInFuture() {
      // returns whether currently viewed week is further in the future than this or next week
      let thisWeekStart = getThisWeekStart(this.userStartWeek, this.userTimezone)
      let currentlyViewedWeekStart = moment(this.startDate)
      return currentlyViewedWeekStart.isSameOrAfter(thisWeekStart.add(2, 'weeks'))
    },
    nowTimeTop() {
      const timeCol = this.$refs.timeColRef
      if (!timeCol) return this.topLineOffset

      const timeColHeight = timeCol.getBoundingClientRect().height
      const minTop = 42 + 22.4 / 2 // 22.4 is height of the now-time marker, divided by 2 because it has transform: translateY(-50%)

      return Math.max(Math.min(this.topLineOffset, timeColHeight), minTop)
    },
  },

  watch: {
    userTimezone: function () {
      this.timezoneCity = this.$store.state.timezonesGlobal.find((x) => x.value === this.userTimezone).city
    },
    anyEntryChanged: function () {
      this.$nextTick(this.updateLine)
    },
    repeatScheduleShow: function () {
      this.$nextTick(this.updateLine)
    },
    fetchingEntries: function () {
      this.$nextTick(this.updateLine)
    },
    startDate: function () {
      if (this.overdueStatus.userTeamWeekStatus !== 'late' || !this.overdueStatus.weekDate) {
        this.showDeadlineMissedBottomBar = false
        return
      }

      if (moment(this.overdueStatus.weekDate, 'DD-MMM-YYYY').isBetween(moment(this.startDate), moment(this.endDate))) {
        this.showDeadlineMissedBottomBar = true
      } else {
        this.showDeadlineMissedBottomBar = false
      }
    },
  },

  async created() {
    this.windowWidth = window.innerWidth
    let userId = this.userId
    if (this.$route.query && this.$route.query.userId) {
      userId = this.$route.query.userId
    }

    this.timezoneCity = this.$store.state.timezonesGlobal.find((x) => x.value === this.userTimezone).city

    const userSettings = this.$store.state.userSettings
    this.userStartWeek = userSettings['week-start'] ? userSettings['week-start'] : 'Monday'

    this.getStartingDate()

    await this.load(userId)

    this.setStartScroll()
    this.updateCurrentTime()

    if (this.isMyPersonal) {
      const res = await this.getOverdueStatus(this.teams[0].teamId)
      if (res.status === 'ok') {
        this.overdueStatus = res

        if (
          this.overdueStatus.userTeamWeekStatus === 'late' &&
          this.overdueStatus.weekDate &&
          moment(this.overdueStatus.weekDate, 'DD-MMM-YYYY').isBetween(moment(this.startDate), moment(this.endDate))
        ) {
          this.showDeadlineMissedBottomBar = true
        }
      }
    }

    if (this.$refs.refCalWithTime) {
      this.calendarWithTimeResizeObserver = new ResizeObserver(() => {
        this.windowWidthResize(true) // shouldRecreateBars = true
      })
      this.calendarWithTimeResizeObserver.observe(this.$refs.refCalWithTime)
    }
  },

  updated() {
    let dayColumn = document.getElementById('dayColumn0')
    if (dayColumn) {
      this.dayColumnOffsetTop = dayColumn.offsetTop
    }
  },

  mounted() {
    window.addEventListener('resize', this.windowWidthResize)
    window.addEventListener('mouseup', this.mouseUp)
    window.addEventListener('blur', this.mouseUp)
    window.addEventListener('touchend', this.mouseUp)
    window.addEventListener('focus', this.windowFocused)
    window.addEventListener('keyup', this.keyUp)

    EventBus.$on('refresh-personal-calendar', this.updateEntriesInBackground)
    EventBus.$on('isBarActivated', this.setIsBarActivated)
    EventBus.$on('api-fixed', this.updateEntriesInBackground)
    EventBus.$on('cancel-confirmed', this.cancelConfirmed)
    EventBus.$on('timezone-changed', this.handleTimezoneChanged)

    this.updateHourHeight()

    this.refreshIntervalId = window.setInterval(() => {
      if (!this.isBarActivated) this.updateCurrentTime()
    }, 10000)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.windowWidthResize)
    window.removeEventListener('mouseup', this.mouseUp)
    window.removeEventListener('blur', this.mouseUp)
    window.removeEventListener('touchend', this.mouseUp)
    window.removeEventListener('focus', this.windowFocused)
    window.removeEventListener('keyup', this.keyUp)
    if (this.refreshIntervalId) {
      window.clearInterval(this.refreshIntervalId)
    }
    EventBus.$off('refresh-personal-calendar', this.updateEntriesInBackground)
    EventBus.$off('isBarActivated', this.setIsBarActivated)
    EventBus.$off('api-fixed', this.updateEntriesInBackground)
    EventBus.$off('cancel-confirmed', this.cancelConfirmed)
    EventBus.$off('timezone-changed', this.handleTimezoneChanged)
    if (this.calendarWithTimeResizeObserver) {
      this.calendarWithTimeResizeObserver.unobserve(this.$refs.refCalWithTime)
    }
  },

  methods: {
    setIsBarActivated(value) {
      this.isBarActivated = value
    },
    openChangeTimezonePopup() {
      EventBus.$emit('open-change-timezone-switch-popup')
    },
    async handleTimezoneChanged() {
      this.getStartingDate()
      this.updateCurrentTime()
      this.$nextTick(this.recreateAllBars)
    },
    setStartScroll() {
      let ratio = Math.min(this.scrollStartTime, this.calculateMinTime())
      ratio -= 0.5
      ratio = ratio / 24
      this.$refs.refCalWithTime.scrollTop = this.$refs.refCalWithTime.scrollHeight * ratio
    },
    calculateMinTime() {
      let min = 24
      for (let entry of this.entries) {
        if (entry.type === 'work') {
          let time = moment(entry.start).tz(this.userTimezone).hours() + moment(entry.start).minute() / 60
          min = Math.min(min, time)
        }
      }
      // console.log(min)
      return min
    },
    updateEntriesInBackground() {
      // don't update entries if user changed something in their own personal calendar or the repeat schedule mode is active
      if (this.submittingEntries || this.fetchingEntries || this.selectWeekShow || (this.isMyPersonal && this.$store.state.preventScheduleLeave)) return

      if (document.visibilityState == 'visible') {
        this.fetchingEntries = true
        let startDate = moment(this.startDate).tz(this.userTimezone)
        let endDate = moment(startDate).tz(this.userTimezone).add(1, 'week')
        let userId = this.$route.query.userId || this.userId

        let valsToCalculateKey = {
          start: moment(startDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
          end: moment(endDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
          userId: userId,
        }
        let key = calculateStoredEntriesKey(valsToCalculateKey)

        this.fetchAndUpdateStore(startDate, endDate, userId, key).then((updatedUsersSchedule) => {
          let newEntries = this.filterAndSortEntriesArray(updatedUsersSchedule.entries)
          if (!isEqual(this.entries, newEntries) && this.checkIfDatesMatch(startDate)) {
            this.entries = newEntries
            this.makeDictionary()
            setTimeout(
              function () {
                this.recreateAllBars()
              }.bind(this),
            )
            this.checkIfShowRepeatSchedule()
            this.updateWorkScheduleHours()
            this.fetchingEntries = false
          } else this.fetchingEntries = false
        })
      }
    },
    checkLast5WeeksForEntries() {
      let todayDate = moment().tz(this.userTimezone)
      let userId = this.$route.query.userId || this.userId

      for (let i = 0; i <= 5; i++) {
        // check if there are any user's entries stored for last 5 weeks

        let weekStartDate = getWeekStartFromDate(todayDate.clone().subtract(i, 'weeks'), this.userStartWeek, this.userTimezone)
        let valsToCalculateKey = {
          start: weekStartDate.clone().utc().format('DD/MM/YYYY HH:mm:ss'),
          end: weekStartDate.clone().add(1, 'week').utc().format('DD/MM/YYYY HH:mm:ss'),
          userId: userId,
        }
        let key = calculateStoredEntriesKey(valsToCalculateKey)

        if (
          this.$store.state.bufferedUsersSchedules[key] &&
          this.filterAndSortEntriesArray(this.$store.state.bufferedUsersSchedules[key].schedule.entries).length > 0
        ) {
          return true // if YES, return true
        } else {
          // if NOT, let's fetch it just to be sure there's nothing there
          this.fetchAndUpdateStore(weekStartDate.clone(), weekStartDate.clone().add(1, 'week'), userId, key).then((result) => {
            if (this.filterAndSortEntriesArray(result.entries).length > 0) {
              // if it turns out there IS something, set the flag to true
              this.isThereAnythingToCopyFromLastFewWeeks = true
            }
          })
        }
      }
      // return false if user really has no entry in last 5 weeks
      return false
    },
    selectWeekClicked() {
      if (!this.checkIfCollision()) {
        this.selectWeekShow = true
        this.showClickAndDragPlaceholder = false
        this.weekIndex = 0
        this.changeWeek(-1)
        this.$store.commit('setPreventScheduleLeave', true)
      } else {
        EventBus.$emit('new-info-bar-msg', {
          msg: 'Collision',
          error: true,
        })
      }
    },
    checkIfCollision() {
      return this.entries.filter((el) => !el.deletedAt).length !== 0
    },
    async changeWeek(week) {
      if (this.weekIndex + week < 0) {
        this.weekIndex += week
        await this.changeDisplayToDifferentWeek(this.weekIndex)
      }
    },
    cancelClicked() {
      this.$emit('cancel-clicked')
    },
    async cancelConfirmed() {
      this.weekIndex = -1
      this.selectWeekShow = false

      let valsToCalculateKey = {
        start: moment(this.startDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
        end: moment(this.endDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
        userId: this.userId,
      }
      let key = calculateStoredEntriesKey(valsToCalculateKey)
      this.entries = this.filterAndSortEntriesArray(this.$store.state.bufferedUsersSchedules[key].schedule.entries)

      this.updateWorkScheduleHours()
      this.makeDictionary()
      setTimeout(
        function () {
          this.recreateAllBars()
        }.bind(this),
      )
      this.showClickAndDragPlaceholder = this.entries.length == 0
      this.checkIfShowRepeatSchedule()
      this.$emit('setAnyEntryChanged', false)
      this.$store.commit('clearTempTimeOffChanges')
    },
    async submit() {
      this.weekIndex = -1
      this.selectWeekShow = false
      this.repeatScheduleShow = false
      this.fetchingEntries = false
      EventBus.$emit('submit-clicked')
    },
    async changeDisplayToDifferentWeek(week) {
      this.fetchingEntries = true
      let startDate = moment(this.startDate).add(week, 'week').toDate()
      let endDate = moment(this.endDate).add(week, 'week').toDate()
      let newEntries = await this.loadEntriesFromTo(this.userId, startDate, endDate)
      this.changeAllEntriesDay(newEntries, -week * 7)

      newEntries = newEntries.filter((x) => moment(x.start).isSameOrAfter(moment(this.startDate)) && moment(x.end).isSameOrBefore(moment(this.endDate)))

      // filter out entries that may have outdated locations
      let filteredEntries = []
      for (let i = 0; i < newEntries.length; i++) {
        let entryToCheck = newEntries[i]

        // if entry.type === 'holiday' update tempTimeOff
        if (entryToCheck.type === 'holiday') {
          let timeOffDurationInDays = moment(entryToCheck.end).diff(moment(entryToCheck.start), 'days')
          let tempTimeOffValue = this.$store.state.tempTimeOffChanges[entryToCheck.teamId] || 0
          tempTimeOffValue += timeOffDurationInDays
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: entryToCheck.teamId, value: tempTimeOffValue })
        }

        let locationIdToCheck = entryToCheck.location.id
        let entryTeam = this.teams.find((team) => team.teamId == entryToCheck.teamId)

        if (!entryTeam) {
          break
        }

        let possibleLocations = await getLocationsCached(entryTeam, this.getLocations)
        possibleLocations = possibleLocations.map((loc) => loc.objectId || loc.id)

        if (possibleLocations.includes(locationIdToCheck)) {
          filteredEntries.push(entryToCheck)
        }
      }
      newEntries = filteredEntries

      this.entries = newEntries
      this.updateWorkScheduleHours()
      this.makeDictionary()
      setTimeout(
        function () {
          this.recreateAllBars()
          this.fetchingEntries = false
        }.bind(this),
      )
    },
    changeAllEntriesDay(entries, days) {
      for (let entry of entries) {
        entry.start = moment(entry.start).add(days, 'days').toDate()
        entry.end = moment(entry.end).add(days, 'days').toDate()
        entry.id = 'brak' + Math.floor(Math.random() * Date.now()).toString()
        entry.changed = true
        // entry.selectWeek = true
      }
    },
    windowFocused() {
      this.updateCurrentTime()
      this.updateEntriesInBackground()
      // this.updateHourHeight()
    },
    makeDictionary() {
      for (const entry of this.entries) {
        this.dictionary[entry.id] = entry
      }
    },
    isDragTimeTo() {
      let ret = true
      if (this.activeEntry && this.activeEntry.type != 'work') {
        let start = moment(this.activeEntry.start).tz(this.activeEntry.timezone ? this.activeEntry.timezone : this.activeEntry.location.timezone)
        let end = moment(this.activeEntry.end).tz(this.activeEntry.timezone ? this.activeEntry.timezone : this.activeEntry.location.timezone)

        let startYMD = parseInt(start.format('YYYYMMDD'))
        let endYMD = parseInt(end.add(-1, 'days').format('YYYYMMDD'))
        if (endYMD <= startYMD) {
          ret = false
        }
      }
      return ret
    },
    dragTimeToValue() {
      if (this.activeEntry) {
        let end = moment(this.activeEntry.end).tz(this.activeEntry.timezone ? this.activeEntry.timezone : this.activeEntry.location.timezone)
        if (this.activeEntry.type == 'work') {
          let h = end.hour()
          let min = end.minutes()

          return this.formatHours(h, min)
        } else {
          return end.add(-1, 'days').locale(this.$i18n.locale).formatLocalized('MMM D, YYYY')
        }
      } else {
        return ''
      }
    },
    dragTimeFromValue() {
      if (this.activeEntry) {
        let start = moment(this.activeEntry.start).tz(this.activeEntry.timezone ? this.activeEntry.timezone : this.activeEntry.location.timezone)
        if (this.activeEntry.type == 'work') {
          let h = start.hour()
          let min = start.minutes()

          return this.formatHours(h, min)
        } else {
          return start.locale(this.$i18n.locale).formatLocalized('MMM D, YYYY')
        }
      } else {
        return ''
      }
    },
    styleForDragTime(bar) {
      if (bar && bar.dragged) {
        let dragTimeWrapper = this.$refs['dragTimeWrapper']
        let time = this.$refs['timeColRef']
        let timeWidth = time.offsetWidth

        const OFFSET = 10
        const OFFSET_BOTTOM = 10

        if (dragTimeWrapper) {
          let timeHeight = dragTimeWrapper.offsetHeight
          let windowHeight = window.innerHeight
          let scrollable = this.$refs['refCalWithTime']
          let scrollTop = scrollable.scrollTop
          let scrollLeft = scrollable.scrollLeft

          let parent = this.$refs['refWeekPersonal']
          let parentBounds = parent.getBoundingClientRect()
          var parentY = parentBounds.top

          let left =
            this.firstBarOfDraggedEntryLeftOffset -
            scrollLeft +
            timeWidth -
            dragTimeWrapper.offsetWidth +
            (this.columns[0].parentWidth - this.columns[0].barWidth) / 2 -
            OFFSET
          let top = this.dayColumnOffsetTop + this.firstBarOfDraggedEntryTopOffset - scrollTop

          if (left - timeWidth < 0) {
            left =
              this.firstBarOfDraggedEntryLeftOffset -
              scrollLeft +
              timeWidth +
              this.columns[0].parentWidth -
              (this.columns[0].parentWidth - this.columns[0].barWidth) / 2 +
              OFFSET
          }

          let sum = top + timeHeight + parentY

          if (sum >= windowHeight - OFFSET_BOTTOM) {
            top = windowHeight - parentY - timeHeight - OFFSET_BOTTOM
          }

          if (top < this.dayColumnOffsetTop + OFFSET) {
            top = this.dayColumnOffsetTop + OFFSET
          }

          return {
            top: top + 'px',
            left: left + 'px',
          }
        }
      }
      return {
        top: '-1000px',
        left: '-1000px',
        visibility: 'hidden',
      }
    },
    shouldShowBlueTimezone() {
      if (this.activeEntry) {
        if (this.activeEntry.timezone) {
          return this.userTimezone != this.activeEntry.timezone
        } else if (this.activeEntry.location && this.activeEntry.location.timezone) {
          return this.userTimezone != this.activeEntry.location.timezone
        }
      } else {
        return false
      }
    },
    updateHourHeight() {
      this.hour_height = (this.$refs['weekWrapper'].offsetHeight - (this.$refs['weekWrapper'].offsetHeight % 27)) / 27
      if (this.hour_height <= 28) {
        this.hour_height = 28
      } else {
        this.hour_height = Math.round(this.hour_height / 4) * 4
      }
    },
    async popupMounted() {
      let bar = this.activeBar
      let entry = this.dictionary[bar.entryId]

      const OFFSET = 10

      if (bar && entry) {
        if (this.schedulePopup.entry !== entry) {
          this.schedulePopup.entry = entry
          this.entryKey++
        }

        // sometimes popupRef.offsetHeight returns too small value, for example 295 instead of 470
        // and it breaks the whole positioning, so here we wait 10ms just to make sure
        // the popup have its final dimensions
        await new Promise((r) => setTimeout(r, 10))

        let scrollable = this.$refs['refCalWithTime']
        let scrollableRectangle = scrollable.getBoundingClientRect()
        let scrollableTop = scrollableRectangle.top

        let popupRef = this.$refs['entryPopup'].$refs['entryPopupRef']
        let parent = popupRef.parentElement
        let parentRect = parent.getBoundingClientRect()
        let parentLeft = parentRect.left

        let width = popupRef.offsetWidth
        let height = popupRef.offsetHeight
        let windowHeight = window.innerHeight
        let dayColumn = document.getElementById('dayColumn' + bar.day)
        let dayColumnRect = dayColumn.getBoundingClientRect()
        var parentX = dayColumnRect.left
        var dayWidth = dayColumnRect.width

        if (this.columns && this.columns.length > 0) {
          var bW = this.columns[0].barWidth
          var pW = this.columns[0].parentWidth
          var barDiff = (pW - bW) / 2 - OFFSET
        }

        // calculate x and y position only when screen is wide enough
        if (window.innerWidth >= 768) {
          // set schedulePopup.positionX
          if (width < parentX - barDiff) {
            this.schedulePopup.positionX = parentX - width - parentLeft + barDiff
          } else {
            this.schedulePopup.positionX = parentX - parentLeft + dayWidth - barDiff
          }
          if (this.schedulePopup.positionX + width >= scrollableRectangle.width) {
            this.schedulePopup.positionX = OFFSET
          } // this.schedulePopup.positionX = parentX - width/2 - parentLeft + dayWidth/2  // in the middle

          // get Y position of click (or touch)
          let clientY = this.lastClickEvent.type == 'touchend' ? this.lastClickEvent.changedTouches[0].clientY : this.lastClickEvent.clientY

          // set schedulePopup.positionY
          if (!clientY) {
            clientY = height
          }
          let positionY = clientY - height / 2 - scrollableTop
          if (positionY + scrollableTop >= windowHeight - height - OFFSET) {
            // if it goes beyond the bottom edge
            positionY = windowHeight - height - OFFSET - scrollableTop
          } else if (positionY + scrollableTop <= OFFSET) {
            // if it goes beyond the top edge
            positionY = OFFSET - scrollableTop
          }
          this.schedulePopup.positionY = positionY
        }

        popupRef.focus() // without this, escape and backspace press do not work
      }
    },
    getStartingDate() {
      if (this.$route.query && this.$route.query.date) {
        this.startDate = getWeekStartFromDate(
          moment.tz(this.$route.query.date, 'DD-MMM-YYYY', this.userTimezone),
          this.userStartWeek,
          this.userTimezone,
        ).toDate()
      } else {
        this.startDate = getThisWeekStart(this.userStartWeek, this.userTimezone).toDate()
      }

      this.endDate = getNextWeekStartFromDate(this.startDate, this.userStartWeek, this.userTimezone).toDate()
    },

    updateCurrentTime() {
      this.currentTime = new moment()

      let tempNowTime = moment()
        .tz(this.userTimezone)
        .format(this.$parent.clock12 ? 'h:mm A' : 'HH:mm')
      if (tempNowTime != this.nowTime) this.nowTime = tempNowTime

      this.updateLine()
    },
    updateLine() {
      let col = this.$refs['entryColumnRef']
      if (!col) return

      let scrollable = this.$refs['refCalWithTime']
      if (!scrollable) return

      let calendarGrid = this.$refs['calendarGrid']
      if (!calendarGrid) return

      this.dashedLineWidth = calendarGrid.getBoundingClientRect().width

      let offsetTop = col[0].offsetTop

      if (this.currentTime.isBefore(moment(this.endDate)) && this.currentTime.isSameOrAfter(moment(this.startDate))) {
        let dd = this.currentTime.diff(this.startDate, 'days')

        let offsetWidth = col[0].getBoundingClientRect().width
        this.straightLineWidth = offsetWidth
        this.leftStraightLineOffset = offsetWidth * dd
      } else {
        this.straightLineWidth = 0
        this.leftStraightLineOffset = -10000
      }

      let scrollTop = scrollable.scrollTop

      let topLineOffset = offsetTop + (this.hour_height / 60.0) * this.currentTime.diff(this.startOfToday, 'minutes')
      if (topLineOffset - scrollTop - offsetTop < 0) {
        this.lineVisible = false
      } else {
        this.topLineOffset = topLineOffset
        this.lineVisible = true
      }
    },
    handleScroll(e) {
      this.updateLine()
    },
    findBarsOfEntry(entry) {
      let ret = []
      for (let i = 0; i < this.columns.length; i++) {
        let bar = this.columns[i].bars.find((x) => x.entryId === entry.id)
        if (bar) {
          ret.push(bar)
        }
      }
      return ret
    },
    activatedBar(bar, entry, entryCloned) {
      this.popupCloseMode = undefined
      this.activeBar = bar
      this.activeEntry = entry
      this.lastUpdatedEntry = entryCloned
    },
    confirmEntryChanged(entry) {
      entry.changed = true

      if (entry.type == 'work' && !entry.isDeleted) {
        let copiedEntry = {
          type: entry.type,
          teamId: entry.teamId,
          location: entry.location,
          durationInMinutes: moment.duration(moment(entry.end).diff(moment(entry.start))).asMinutes(),
          timezone: entry.timezone,
        }
        this.$store.commit('setCopiedEntry', copiedEntry)
      }

      this.$emit('setAnyEntryChanged', true)
    },
    deleteEntry(entry, popupActive = false) {
      entry = this.entries.find((e) => e.id === entry.id) // in case entries updated in background in the meantime and 'entry' no longer references the actual data in 'this.entries'
      entry.deletedAt = moment().toDate()
      entry.isDeleted = true
      this.schedulePopup.active = popupActive
      this.confirmEntryChanged(entry)
      for (let i = 0; i < this.columns.length; i++) {
        let barIndex = this.columns[i].bars.findIndex((x) => x.entryId === entry.id)
        if (barIndex !== -1) this.columns[i].bars.splice(barIndex, 1)
      }

      this.updateWorkScheduleHours()
      this.checkIfShowRepeatSchedule()

      // update tempTimeOff
      if (entry.type === 'holiday') {
        let timeOffDurationInDays = moment(entry.end).diff(moment(entry.start), 'days')
        let tempTimeOffValue = this.$store.state.tempTimeOffChanges[entry.teamId] || 0
        tempTimeOffValue -= timeOffDurationInDays
        this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: entry.teamId, value: tempTimeOffValue })
      }
    },

    closePopup(mode) {
      this.schedulePopup.active = false
      if (mode == 'deactivated') {
        this.popupCloseMode = mode
      }
    },

    formatHours(hours, minutes) {
      if (this.$parent.clock12) {
        var ampm = hours >= 12 || hours == 24 ? 'PM' : 'AM'
        hours = hours % 12
        if (hours == 0) hours = 12
        return hours + (minutes ? ':' + minutes + ' ' : ' ') + ampm
      } else {
        let hoursDisplay = hours % 24 < 10 ? '0' + (hours % 24) : hours % 24
        let minutesDisplay = minutes ? (minutes < 10 ? '0' + minutes : minutes) : '00'
        return hoursDisplay + ':' + minutesDisplay
      }
    },

    key(obj) {
      return obj.id
    },
    holidayChanged(entry, time) {
      let index = this.entries.findIndex((x) => x.id === entry.id)

      this.entries[index].start = time[0]
      this.entries[index].end = time[1]
    },
    openPopup(bar) {
      this.$emit('open-popup', {
        bar: bar,
        active: true,
        entry: this.dictionary[bar.entryId],
      })
    },
    async columnClicked(e, column) {
      // if(this.selectWeekShow)
      //   return

      this.lastClickEvent = e
      const MAX_MOVE_WHILE_CLICKING = 20
      clearTextSelection()
      if (this.schedulePopup.active || (this.popupCloseMode && this.popupCloseMode == 'deactivated')) {
        this.popupCloseMode = undefined
        this.schedulePopup.active = false
        if (this.activeBar) {
          this.activeBar.dragged = false
        }
      } else {
        if (this.activeBar && this.activeEntry && !(this.activeEntry.isDeleted || this.activeEntry.deletedAt)) {
          // console.log('|||| efect', this.activeBar.draggedEffectively)
          if (!this.activeBar.draggedEffectively) {
            this.positionPopupEntry(this.activeBar, this.activeEntry)
            this.activeBar.enabled = true
          }
          this.activeBar.dragged = false
        } else {
          // if scrolled anything then do not create entry
          if (column.mouseDownScrollX == window.top.scrollX) {
            let diffY = Math.abs(column.mouseDownEvent.y - e.y)
            if (diffY <= MAX_MOVE_WHILE_CLICKING) {
              await this.createEntry(column.startOfDay, e)
              this.repeatScheduleShow = false
              this.showClickAndDragPlaceholder = false
            }
          }
        }
      }
    },
    createEntryCopy(entry, newStart, newEnd, type = null) {
      let newEntry = JSON.parse(JSON.stringify(entry))
      newEntry.start = newStart
      newEntry.end = newEnd

      const newEntryId = 'brak' + Date.now()
      newEntry.id = newEntryId

      if (type != null) {
        newEntry.type = type
      }

      this.confirmEntryChanged(newEntry)
      this.entries.push(newEntry)
      this.dictionary[this.key(newEntry)] = newEntry

      for (let i = 0; i < this.$refs['refColumn'].length; i++) {
        let column = this.$refs['refColumn'][i]
        column.createBarOfEntry(newEntry)
      }

      this.updateWorkScheduleHours()
    },
    async createEntry(date, e) {
      if (!this.isMyPersonal || this.submittingEntries || this.fetchingEntries) return
      const target = e.target || e.srcElement
      let par = getAncestorOfClass(target, 'singleHourLine')
      if (par) {
        var mouseYPosition = par.offsetTop
      } else {
        var mouseYPosition = e.offsetY
      }

      let team
      for (let i = 0; i < this.teams.length; i++) {
        team = this.teams[i]
        const tempLocations = await getLocationsCached(team, this.getLocations)
        if (tempLocations.length > 0) break
      }
      let defaultTeamId = this.$store.state.copiedEntry.teamId || localStorage.teamIdEdited || this.$store.state.userSettings['last-used-team-id']
      if (defaultTeamId) {
        for (var i = 0; i < this.teams.length; i++) {
          if (this.teams[i].teamId === defaultTeamId) {
            team = this.teams[i]
            break
          }
        }
      }
      let newEntryTeamId = team.teamId

      let moduloDiff = mouseYPosition % this.hour_height
      if (moduloDiff > this.hour_height / 2) {
        moduloDiff = -moduloDiff + this.hour_height
      }

      const newEntryStartHour = Math.round((mouseYPosition - moduloDiff) / this.hour_height)
      const firstEntryStartDate = this.isFarInFuture
        ? moment(date).tz(this.userTimezone).startOf('day').toDate()
        : moment(date).add(newEntryStartHour, 'hours').toDate()

      let newEntryStartDate, newEntryEndDate

      if (this.isFarInFuture) {
        newEntryStartDate = firstEntryStartDate
        newEntryEndDate = moment(newEntryStartDate).add(1, 'days').toDate()
      } else {
        let entryDuration = this.$store.state.copiedEntry.durationInMinutes || 8 * 60
        for (let i = 0; i <= 3; i++) {
          newEntryStartDate = moment(firstEntryStartDate)
            .add(i * 0.25, 'hours')
            .toDate()
          newEntryEndDate = maxPossibleEntryFromStartPoint(this.entries, newEntryStartDate, entryDuration, newEntryTeamId, true)
          if (newEntryEndDate) break
        }
        if (newEntryEndDate == null) {
          return /* cant create entry over there */
        }
      }

      const locations = await getLocationsCached(team, this.getLocations)
      let newEntryLocation = locations[0]

      // it seems that location object of old teams (like clavo) has 'objectId' property, whereas in new teams it's just 'id'
      let defaultLocationId = this.$store.state.copiedEntry.location
        ? this.$store.state.copiedEntry.location.id || this.$store.state.copiedEntry.location.objectId
        : localStorage.locationIdEdited || this.$store.state.userSettings['last-used-location-id']

      if (defaultLocationId) {
        for (var i = 0; i < locations.length; i++) {
          if (locations[i].objectId === defaultLocationId || locations[i].id === defaultLocationId) {
            newEntryLocation = locations[i]
            break
          }
        }
      }
      if (newEntryLocation) {
        const newEntryType = this.isFarInFuture ? 'holiday' : 'work'
        const newEntryId = 'brak' + e.timeStamp
        let defaultTimezone = this.$store.state.copiedEntry.timezone || localStorage.entryTimezoneEdited || this.userTimezone
        let timezone = this.isFarInFuture ? this.userTimezone : newEntryLocation.timezone ? newEntryLocation.timezone : defaultTimezone

        const newEntry = new Entry(
          newEntryId,
          newEntryStartDate,
          newEntryEndDate,
          newEntryType,
          newEntryLocation,
          this.$store.state.copiedEntry.comment,
          newEntryTeamId,
          timezone,
        )
        if (this.isFarInFuture && collides(this.entries, newEntry, true)) {
          return /* cant create entry over there */
        }
        this.confirmEntryChanged(newEntry)

        // todo if collides modify appropriately

        this.entries.push(newEntry)
        this.dictionary[this.key(newEntry)] = newEntry // todo remove that

        // this.entryBarUpdate(newEntry, null)

        for (let i = 0; i < this.$refs['refColumn'].length; i++) {
          let column = this.$refs['refColumn'][i]
          column.createBarOfEntry(newEntry)
        }

        let teamHolidayInfo = this.$store.state.holidayInfo[Parse.User.current()._getId()].holidayInfo.find((team) => team.teamId == newEntryTeamId)
        if (newEntryType == 'holiday' && teamHolidayInfo.holiday[moment().format('YYYY')].limit == undefined) {
          EventBus.$emit('open-holidays-popup', newEntryTeamId)
        }

        // update tempTimeOff
        if (newEntryType === 'holiday') {
          let timeOffDurationInDays = moment(newEntryEndDate).diff(moment(newEntryStartDate), 'days')
          let tempTimeOffValue = this.$store.state.tempTimeOffChanges[newEntryTeamId] || 0
          tempTimeOffValue += timeOffDurationInDays
          this.$store.commit('setTempTimeOffChangesForOneTeam', { teamId: newEntryTeamId, value: tempTimeOffValue })
        }
      } else {
        this.showError('noWorkplacesPleaseContactYourTeamAdmin')
      }
      this.updateWorkScheduleHours()
    }, // CREATE ENTRY

    entryChanged(entry, mode, oldData) {
      entry = this.entries.find((e) => e.id === entry.id) // in case entries updated in background in the meantime and 'entry' no longer references the actual data in 'this.entries'
      this.confirmEntryChanged(entry)

      if (!entry.isDeleted) {
        if (collides(this.entries, entry)) {
          if (this.$refs['entryPopup']) {
            this.$refs['entryPopup'].collidingEntriesFound(mode, oldData)
          }
          return
        }

        this.activeEntry = entry
        this.entryBarUpdate(this.activeEntry, this.activeBar, mode)
      }
    },
    applyEntryChanges() {
      if (this.lastUpdatedEntry && this.activeEntry) {
        let activeEntry = JSON.stringify(this.activeEntry)
        let lastUpdatedEntry = JSON.stringify(this.lastUpdatedEntry)
        if (activeEntry !== lastUpdatedEntry) {
          this.confirmEntryChanged(this.activeEntry)
        }
      }
    },
    keyUp(e) {
      let popupRef = this.$refs['entryPopup']
      if (e.key === 'Escape' && (!popupRef || !popupRef.textInput)) {
        if (this.schedulePopup.active) {
          this.schedulePopup.active = false
        } else {
          this.deactivateAllBars()
          this.activeEntry = null
          this.activeBar = null
        }
      }
    },
    mouseUp(e) {
      // console.log('MOUSE UP active bar', this.activeBar)
      const target = e.target || e.srcElement
      if (checkIfTargetFromClass(target, 'entryPopup')) {
        return
      }

      // remove bar duplicate if exists
      let activeBar = this.activeBar

      // remove empty and duplicates
      if (activeBar) {
        // console.log('active bar day', activeBar.day)
        let entryId = activeBar.entryId
        let bars = this.columns[activeBar.day].bars
        let nrFound = 0
        let toRemove = undefined
        for (var i = 0; i < bars.length; i++) {
          let bar = bars[i]
          if (bar.entryId == entryId) {
            nrFound++
          }
          if (!bar.h || bar.h == 0 || nrFound > 1) {
            toRemove = i
            break
          }
        }
        if (toRemove != undefined) {
          bars.splice(toRemove, 1)
        }

        // if clicked outside clalendar always close popup
        if (!checkIfTargetFromClass(target, 'day-wrapper')) {
          this.schedulePopup.active = false
          this.activeBar = null
        }
      } else {
        this.schedulePopup.active = false
        this.activeBar = null
      }

      this.applyEntryChanges()

      // this.entryBarUpdate(this.lastUpdatedEntry, this.activeBar)
      this.activeEntry = null
      // console.log('active entry set to null', this.activeEntry)
      // this.activeBar = null
      this.popupCloseMode = undefined
    },
    entryBarUpdate(entry, bar, mode = null, data) {
      this.updateWorkScheduleHours()
      // console.log('entryBar update',bar.day,bar.entryId)
      this.editMode = mode
      if (entry.type === 'work') {
        if (this.$refs['entryPopup']) {
          this.$refs['entryPopup'].makeTimeOptions()
        }
      }
      let barFound = false
      let modeUpdateAll = mode != 'drag' && mode != 'resize-bottom' && mode != 'resize-top'
      for (let i = 0; i < this.$refs['refColumn'].length; i++) {
        let column = this.$refs['refColumn'][i]
        let barSelected = column.bars.find((x) => x.entryId == entry.id && (modeUpdateAll || !Object.is(x, bar)))
        let endOfDay = moment(this.startDate).add(i + 1, 'days')
        let startOfDay = moment(this.startDate).add(i, 'days')

        if (!barFound && barSelected) {
          barFound = true
          let col = this.$refs['entryColumnRef'][i]
          if (col) {
            this.firstBarOfDraggedEntryLeftOffset = col.offsetLeft
            this.firstBarOfDraggedEntryTopOffset = barSelected.y
            this.firstBarOfDraggedEntryColumnIndex = i
          }
        } else if (barSelected && data && data.draggedToColumn) {
          if (data.draggedToColumn == i) {
            let col = this.$refs['entryColumnRef'][i]
            if (col && barSelected.type === 'work') {
              this.firstBarOfDraggedEntryLeftOffset = col.offsetLeft
              this.firstBarOfDraggedEntryTopOffset = barSelected.y
              this.firstBarOfDraggedEntryColumnIndex = i
            }
          }
        }

        if (moment(entry.start).isBefore(endOfDay) && moment(entry.end).isAfter(startOfDay)) {
          if (barSelected) {
            if (!mode || mode == 'time' || mode == 'drag' || mode == 'resize-top' || mode == 'resize-bottom' || mode == 'type' || mode == 'timezone') {
              barSelected.y = column.startPositionOfBar(entry.start, entry.timezone)
              barSelected.h = column.barHeightMinutes(entry.start, entry.end, entry.timezone)

              barSelected.endPosition = barSelected.h + barSelected.y
            }
            if (mode == 'location' || mode == 'team' || mode == 'type') {
              setBarColor(barSelected, entry)
              setBarTitle(barSelected, entry)
              if (entry.teamId) {
                let team = this.teams.find((x) => x.teamId === entry.teamId)
                barSelected.team = team
              }
            }
            this.updateBarHandlesInBar(barSelected, entry)
          } else {
            let newBar = { ...bar }
            newBar.endOfDay = endOfDay
            newBar.day = i
            newBar.startOfDay = startOfDay
            newBar.y = column.startPositionOfBar(entry.start, entry.timezone)
            newBar.h = column.barHeightMinutes(entry.start, entry.end, entry.timezone)
            newBar.endPosition = newBar.h + newBar.y
            newBar.key = 'bar' + new Date().getUTCMilliseconds()
            newBar.dragged = false
            setBarColor(newBar, entry)
            setBarTitle(newBar, entry)
            // newBar.color1 = 'cyan'
            column.bars.push(newBar)
            this.updateBarHandlesInBar(newBar, entry)
          }
        } else {
          if (barSelected) {
            this.deleteBarFromColumn(column, barSelected)
          }
        }
      }

      this.updateBarHandlesInBar(bar, entry)
    }, // ENTRY BAR UPDATE

    deleteBarFromColumn(column, barSelected) {
      for (var i = 0; i < column.bars.length; i++) {
        if (column.bars[i] === barSelected) {
          column.bars.splice(i, 1)
        }
      }
    },
    updateWorkScheduleHours() {
      this.workScheduled = { total: 0 }
      this.holidayScheduled = 0

      for (const entry of this.entries) {
        if (!(entry.deletedAt || entry.isDeleted)) {
          const start = moment(entry.start).isAfter(moment(this.startDate)) ? moment(entry.start) : moment(this.startDate)
          const end = moment(entry.end).isBefore(moment(this.endDate)) ? moment(entry.end) : moment(this.endDate)
          let entriesDuration = moment.duration(end.diff(start)).asHours()
          if (entriesDuration < 0) entriesDuration = 0

          if (entry.type == 'work') {
            this.workScheduled.total += entriesDuration
            if (this.workScheduled[entry.teamId]) {
              this.workScheduled[entry.teamId] += entriesDuration
            } else {
              this.workScheduled[entry.teamId] = entriesDuration
            }
          } else if (entry.type === 'holiday') {
            this.holidayScheduled += entriesDuration / 24
          }
        }
      }

      for (const [key, value] of Object.entries(this.workScheduled)) {
        this.workScheduled[key] = Math.round(this.workScheduled[key] * 100) / 100
      }

      this.$emit('change-work-hours', this.workScheduled)
    },

    updateBarHandlesInBar(bar, entry) {
      for (let i = 0; i < this.columns.length; i++) {
        let column = this.columns[i]
        for (let j = 0; j < column.bars.length; j++) {
          let jBar = column.bars[j]
          if (jBar.entryId === bar.entryId) {
            let handles = []
            if (entry.type === 'work') {
              if (moment(entry.start).isSameOrAfter(column.startOfDay) && moment(entry.start).isBefore(column.endOfDay)) {
                handles.push('tm')
              }
              if (moment(entry.end).isSameOrBefore(column.endOfDay) && moment(entry.end).isAfter(column.startOfDay)) {
                handles.push('bm')
              }
            }
            jBar.handles = handles
          }
        }
      }
    },
    recreateAllBars() {
      for (let i = 0; i < this.$refs['refColumn'].length; i++) {
        let column = this.$refs['refColumn'][i]
        column.recreateAllBars()
      }
    },
    deactivateAllBars() {
      for (let i = 0; i < this.$refs['refColumn'].length; i++) {
        let column = this.$refs['refColumn'][i]
        column.disableBar(this.activeBar)
        // for (let j = 0; j < column.bars.length; j++) {
        //   column.bars[j].handles = []
        //   column.bars[j].enabled = false
        // }
      }
    },

    windowWidthResize(shouldRecreateBars = false) {
      this.windowWidth = window.innerWidth
      // prevents hiding of popup on mobiles
      // if (window.innerWidth >= 768) this.schedulePopup.active = false
      this.updateLine()

      if (!shouldRecreateBars) return

      clearTimeout(this.recreateBarsOnResizeTimeoutId)
      this.recreateBarsOnResizeTimeoutId = setTimeout(
        function () {
          this.recreateAllBars()
        }.bind(this),
        this.recreateBarsOnResizeTimeoutInterval,
      )
      // this.updateHourHeight()
    },

    async positionPopupEntry(bar, entry) {
      this.schedulePopup.positionY = -10000
      let team = this.teams.find((x) => x.teamId === entry.teamId)
      if (team) {
        this.schedulePopup.locations = await getLocationsCached(team, this.getLocations)
        if (this.schedulePopup.entry !== entry) {
          this.schedulePopup.entry = entry
          this.entryKey++
        }
        this.schedulePopup.active = true

        // let popupRef = this.$refs['entryPopup']
        // let dayColumn = document.getElementById('dayColumn' + bar.day)
        // let posLeft = dayColumn.offsetLeft

        // let tempWidth = dayColumn.offsetWidth
        // this.schedulePopup.positionX = posLeft + tempWidth
      }
    },

    async load(userId, shoudRequestEntries = true) {
      this.repeatScheduleShow = false
      this.fetchingEntries = true
      await this.loadEntries(userId ? userId : this.userId, shoudRequestEntries)
      this.updateWorkScheduleHours()
      if (this.teams.length == 0) {
        this.teams = this.$store.state.teams
        this.teamsDict.clear()
        for (const team of this.teams) {
          this.teamsDict.set(team.teamId, team)
        }
      }

      if (this.filteredTeams.length == 0) {
        this.filteredTeams = this.teams
        if (this.isMyPersonal) {
          this.fetchTeamsLocations().then((filteredTeams) => {
            this.filteredTeams = filteredTeams
          })
        }
      }

      this.makeDictionary()

      this.summaryKey += 1 // todo why if i delete it, the program crashes ???

      this.recreateAllBars()

      this.updateLine()

      let isCurrentUser = this.$route.query ? this.$route.query.userId : this.userId
      isCurrentUser = isCurrentUser === Parse.User.current().id

      this.checkIfShowRepeatSchedule()
    },

    async fetchTeamsLocations() {
      let tempFilteredTeams = []
      for (let i = 0; i < this.teams.length; i++) {
        const tempLocations = await getLocationsCached(this.teams[i], this.getLocations)
        if (tempLocations.length > 0) tempFilteredTeams.push(this.teams[i])
      }
      return tempFilteredTeams
    },

    hideDeadlineMissedBar() {
      if (this.overdueStatus.userTeamWeekStatus === 'late' && this.overdueStatus && this.overdueStatus.weekDate) {
        if (moment(this.overdueStatus.weekDate, 'DD-MMM-YYYY').isBetween(moment(this.startDate), moment(this.endDate))) {
          this.overdueStatus.userTeamWeekStatus = 'ok'
          this.showDeadlineMissedBottomBar = false
        }
      }
    },

    checkIfShowRepeatSchedule() {
      if (this.entries.length === 0 && this.isMyPersonal) {
        this.showClickAndDragPlaceholder = true

        let mid = getNextWeekStartDate(this.userStartWeek, this.userTimezone).clone()
        let start = mid.clone().subtract(1, 'week')
        let end = mid.clone().add(1, 'week')

        if (moment(this.startDate).isBetween(start, end, undefined, '[)')) {
          this.isThereAnythingToCopyFromLastFewWeeks = this.checkLast5WeeksForEntries()
          this.repeatScheduleShow = true
        }
      } else {
        this.repeatScheduleShow = false
        this.showClickAndDragPlaceholder = false
      }
    },

    /**
     * Gets an array of Entry object out of database response.
     * It sorts the entries and filters out deleted ones.
     * @return {[Entry]} Sorted array of entries
     */
    async loadEntries(userId, shouldRequestEntries = true) {
      this.entries = await this.loadEntriesFromTo(userId, this.startDate, this.endDate, shouldRequestEntries)
    },
    async loadEntriesFromTo(userId, startDate, endDate, shouldRequestEntries = true) {
      startDate = moment(startDate).tz(this.userTimezone)
      endDate = moment(startDate).tz(this.userTimezone).add(1, 'week')

      let result = await this.fetchHelper(startDate, endDate, userId, shouldRequestEntries)
      return this.filterAndSortEntriesArray(result.entries)
    },
    async fetchHelper(startDate, endDate, userId, shouldRequestEntries = true) {
      let valsToCalculateKey = {
        start: moment(startDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
        end: moment(endDate).tz(this.userTimezone).utc().format('DD/MM/YYYY HH:mm:ss'),
        userId: userId,
      }
      let key = calculateStoredEntriesKey(valsToCalculateKey)

      // check if entries are stored
      let result
      if (this.$store.state.bufferedUsersSchedules[key]) {
        // if YES: save to result variable
        result = this.$store.state.bufferedUsersSchedules[key].schedule

        let teamMateDetails = this.extractTeamMateDetails(result)
        if (this.$store.state.followedList[userId]) {
          teamMateDetails.isFollowed = this.$store.state.followedList[userId].isFollowed
        }
        EventBus.$emit('updateTeamMateInPersonal', teamMateDetails)

        if (this.$store.state.holidayInfo[userId]) {
          EventBus.$emit('updateHolidayInfo', this.$store.state.holidayInfo[userId].holidayInfo)
        } else {
          EventBus.$emit('updateHolidayInfo', result.teams)
        }

        if (!this.selectWeekShow && shouldRequestEntries) {
          // don't update if in copy week schedule mode
          this.$store.commit('updateLookUpOfBufferedUsersSchedules', { key, timestamp: new Date().getTime() })
          this.fetchingEntries = true
          // fetch user's schedule in case something changed since it was stored
          this.fetchAndUpdateStore(startDate, endDate, userId, key).then((updatedUsersSchedule) => {
            // compare fetched schedule to the displayed one
            let newEntries = this.filterAndSortEntriesArray(updatedUsersSchedule.entries)
            if (!isEqual(this.entries, newEntries) && this.checkIfDatesMatch(startDate)) {
              // update the store if they're not the same; also check if date of fetched entries match the one in url
              this.entries = newEntries
              this.makeDictionary()
              setTimeout(
                function () {
                  this.recreateAllBars()
                }.bind(this),
              )
              this.checkIfShowRepeatSchedule()
              this.updateWorkScheduleHours()
              this.fetchingEntries = false
            } else {
              this.fetchingEntries = false
            }
            this.showScheduleEntryPopupIfNeeded()
          })
        } else if (!this.selectWeekShow && !shouldRequestEntries) {
          this.checkIfShowRepeatSchedule()
          this.fetchingEntries = false
        }
      } else {
        // if NOT: fetch and save to result variable
        result = await this.fetchAndUpdateStore(startDate, endDate, userId, key)
        this.fetchingEntries = false
      }
      return result
    },

    showScheduleEntryPopupIfNeeded() {
      if (this.$route.query && this.$route.query.entryId) {
        this.entry = this.entries.find((e) => e.id === this.$route.query.entryId)
        this.activeEntry = this.entry
        this.schedulePopup.entry = this.entry
        if (this.entry) {
          let bars = this.findBarsOfEntry(this.entry)
          if (bars.length > 0) {
            this.activeBar = bars[0]

            for (let i = 0; i < this.columns.length; i++) {
              let bar = this.columns[i].bars.find((x) => x.entryId === this.entry.id)
              if (bar) {
                this.columns[i].inializeBarChangesPhase(bar)
              }
            }
            this.positionPopupEntry(this.activeBar, this.entry)
          }
        }
      }
    },

    filterAndSortEntriesArray(entries) {
      if (!entries) return []
      const entriesArray = Array.from(entries, (entry) => {
        if (typeof entry.deletedAt !== 'undefined' || typeof entry.isDeleted !== 'undefined') {
          return null
        } else {
          return new Entry(entry.id, entry.start, entry.end, entry.type, entry.location, entry.comment, entry.teamId, entry.timezone)
        }
      })
      const notDeletedEntries = entriesArray.filter((entry) => entry !== null)
      notDeletedEntries.sort(Entry.sortFn)
      return notDeletedEntries
    },

    async fetchAndUpdateStore(startDate, endDate, userId, key) {
      const res = await this.getEntriesWithUserId(startDate.toDate(), endDate.toDate(), userId)
      if (res.status === 'ok') {
        // add schedule to the store
        let usersScheduleToStore = {
          startDate: startDate,
          endDate: endDate,
          userId: userId,
          schedule: res.schedule[0],
          lastLookUp: new Date().getTime(),
        }
        this.$store.commit('addWeekToBufferedUsersSchedules', { key, value: usersScheduleToStore })
        this.$store.commit('limitBufferedUsersSchedules')

        // add holidayInfo to the store
        let holidayInfoToStore = {
          holidayInfo: res.schedule[0].teams,
          lastLookUp: usersScheduleToStore.lastLookUp,
        }
        this.$store.commit('setHolidayInfo', { key: userId, value: holidayInfoToStore })
        this.$store.commit('limitHolidayInfo')

        // add followedList to the store
        let followedListToStore = {
          isFollowed: res.schedule[0].isFollowed,
          lastLookUp: usersScheduleToStore.lastLookUp,
        }
        this.$store.commit('setFollowedList', { key: userId, value: followedListToStore })
        this.$store.commit('limitFollowedList')

        EventBus.$emit('updateHolidayInfo', this.$store.state.holidayInfo[userId].holidayInfo)

        let teamMateDetails = this.extractTeamMateDetails(res.schedule[0])
        EventBus.$emit('updateTeamMateInPersonal', teamMateDetails)

        return res.schedule[0]
      } else if (res.error === 'userNotFound') {
        this.showServerError(res)
        setTimeout(() => {
          this.$router.push('/')
        }, 2500)
        return {}
      } else {
        this.showServerError(res)
        return {}
      }
    },
    checkIfDatesMatch(startDate) {
      let urlDate = moment()
      if (this.$route.query && this.$route.query.date) {
        urlDate = moment.tz(this.$route.query.date, 'DD-MMM-YYYY', this.userTimezone).startOf('day')
      }
      urlDate = getWeekStartFromDate(urlDate, this.userStartWeek, this.userTimezone)
      return urlDate.isSame(startDate)
    },
    extractTeamMateDetails(schedule) {
      let result = {}
      for (const prop in schedule) {
        if (prop !== 'entries' && prop !== 'teams') result[prop] = schedule[prop]
      }
      return result
    },
  },
}
</script>

<style scoped lang="scss">
.week-personal {
  position: relative;
  display: grid;
  grid-template-rows: auto 0px;

  &.bottomBar {
    // grid-template-rows: auto 72px;
    grid-template-rows: 1fr minmax(72px, auto);
  }

  .epopup-enter-active {
    position: absolute;
    transition: opacity 0.36s;
    z-index: 1000;
  }
  .epopup-leave-active {
    position: absolute;
    transition: opacity 0.36s;
    z-index: 1000;
  }

  .epopup-enter, .epopup-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .repeat-schedule-bar {
    padding: 17px 20px;
    // height: 72px;
    width: 100%;
    // z-index: 5;
    background-color: $blue;
    // position: fixed;
    bottom: 0;
    button {
      min-width: 100px;
      border: 1px solid white;
    }
    .r-s-start {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: space-between;
      position: relative;
      @include respond-below(xs) {
        flex-direction: column;
      }
    }
    .r-s-text {
      line-height: 20px;
      // position: absolute;
      color: #ffffff;
      font-size: 16px;
      font-family: $bold;
      letter-spacing: 0.3px;
      padding-right: 10px;
      @include respond-below(xs) {
        padding-bottom: 18px;
        padding-right: 0;
        text-align: center;
      }
    }
    .r-s-buttons {
      // position: absolute;
      // right: 20px;
      white-space: nowrap;
    }
    .r-s-selected {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;

      @include respond-below(xs) {
        &.centered {
          justify-content: center;
        }
      }

      .r-s-left-section {
        display: flex;
        align-items: center;
      }

      .arrow {
        height: 32px;
        width: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          margin-right: 4px;
        }
        &.next {
          transform: scaleX(-1);
          margin-right: 18px;
        }
        &.disabled {
          cursor: unset;
        }
        &.prev {
        }
        &:hover {
          &:not(&.disabled) {
            background: rgba(255, 255, 255, 0.2);
          }
        }
      }
      .r-s-s-text {
        // padding: 0 0 0 85px;
        color: #ffffff;
        font-size: 16px;
        font-family: $bold;
        letter-spacing: 0.3px;
        @include respond-below(xs) {
          display: none;
        }
      }
    }
    &.warning-bar {
      background-color: $red;
    }
  }
  .drag-time-wrapper {
    position: absolute;
    z-index: 5;
    color: white;
    width: 84px;
    font-family: $semibold;
    font-size: 13px;
    line-height: 18px;
    text-align: left;
    background: $blue;
    display: inline-block;
    padding: 5px 7px;
    border: 0 solid $blue;
    box-shadow: 0 4px 8px 0 rgba(3, 13, 70, 0.2);
    span {
      font-family: $semibold;
    }
    .drag-time {
      font-family: $semibold;
    }

    .drag-timezone {
      margin-top: 12px;
      font-size: 12px;
      line-height: 16px;
    }
  }

  .schedulePopup {
    z-index: 2000;
    position: absolute;
    @include respond-below(sm) {
      position: fixed;
      width: auto;
    }
  }
  .week-wrapper {
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;

    .dashed-cal-border {
      position: absolute;
      pointer-events: none;
      width: 100%;
      z-index: 6;
      height: 100%;
      padding-top: 44px;
      display: flex;
      border: 2px dashed $blue;
      justify-content: center;
      align-items: center;
      .click-schedule-image {
        display: flex;
        align-items: start;
        flex-direction: column;
        color: $blue;
        @include font-rule('averta-bold');
        font-size: 16px;
        letter-spacing: 0;
        line-height: 20px;
        text-align: center;
        padding-bottom: 60px;
        img {
          align-self: center;
          margin-bottom: 20px;
        }
      }
      &.warning-border {
        border: 2px dashed $red;
      }
    }

    .time-timezone {
      position: absolute;
      z-index: 5;
      border-bottom: 1px solid $athens-gray;
      height: 42px;
      max-height: 42px;
      cursor: pointer;
      background-color: white;
      transition: background-color 0.15s;

      div {
        padding: 12px 10px 12px 18px;
        font-size: 14px;
        line-height: 18px;
        letter-spacing: 0.5px;
        font-family: $bold;
        color: $blue;
        text-align: left;
        white-space: nowrap;
      }

      img {
        display: block;
        margin: auto;
        transform: translateY(9px);
      }

      &:hover {
        background-color: $white-lilac;
      }
    }

    .calendar-with-time {
      width: 100%;
      position: absolute;
      display: flex;
      overflow-x: auto;
      height: 100%;
      //overflow-y: scroll;
      // position: relative;

      .time-column {
        position: sticky;
        left: 0;
        background-color: white;
        z-index: 4;
        font-family: $regular;
        font-size: 12px;
        text-align: right;
        color: $bluebell;

        .now-time {
          position: absolute;
          font-size: 14px;
          padding: 2px 6px;
          left: 0px;
          transform: translateY(-50%);
          border-radius: 2px;
          background-color: $turquoise;
          color: white;
          font-family: $bold;
          z-index: 3;
          text-align: center;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
          @include respond-below(sm) {
            width: 75px;
          }
        }

        .dashed-line {
          position: absolute;
          height: 1px;
          border-bottom: 1px dashed $turquoise;
          z-index: 2;
          pointer-events: none;
        }

        .time-text {
          display: flex;
          position: absolute;
          right: 20px;
          transform: translateY(-50%);
          &:first-child {
            visibility: hidden;
          }
        }
      }

      .calendar-grid {
        display: flex;
        align-items: stretch;
        position: absolute;
        min-width: 380px;

        .dashed-line {
          position: absolute;
          height: 1px;
          border-bottom: 1px dashed $turquoise;
          z-index: 2;
          width: 100%;
          pointer-events: none;
        }
        .straight-line {
          position: absolute;
          height: 1px;
          background-color: $turquoise;
          z-index: 2;
          pointer-events: none;
        }
        .dot {
          position: absolute;
          height: 8px;
          width: 8px;
          left: -4px;
          border-radius: 4px;
          background-color: $turquoise;
          z-index: 4;
        }
        .dayColumn {
          .column-date {
            flex: 1 1 0;
            text-align: center;
            padding-top: 0px;
            padding-bottom: 3px;
            text-transform: uppercase;
            .week-day,
            .day-date {
              font-family: $bold;
              font-size: 12px;
              line-height: 18px;
              letter-spacing: 0.2px;
            }
            &.today {
              background: $blue;
              color: white;
            }

            &:not(.today) {
              &.weekendDay {
                color: $bluebell-light;
              }
            }
          }

          display: flex;
          justify-content: stretch;
          padding: 9px 0 8px;
          background-color: white;
          max-height: 42px;
          position: sticky;
          top: 0;
          z-index: 3;
          border-bottom: 1px solid $athens-gray;
        }
      }
    }
  }
}
</style>
